import React from 'react';
import { componentService } from 'js/services/component.service';

export const GameHistory = React.lazy(() => import(/* webpackChunkName: "game-history" */ './GameHistory'));

componentService.registerPageComponents({ 'game-history': GameHistory });
